// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a663bf5","519":"08f017a0","569":"f1684f14","571":"8fa2c7d5","579":"746a0140","595":"91e40621","717":"192350db","875":"80d7e2e7","927":"626a500e"}[chunkId] + ".chunk.js";
};